import * as React from 'react';
import { Typography, Box, Checkbox } from '@mui/material';
import { connect } from "react-redux";
import { MainInput, MainPassword } from '../../app/components/Styles';
import { NavLink, useNavigate } from 'react-router-dom';
import { signUp } from '../../app/store/actions/authActions';
import { MarketingFormPage, MarketingButton } from '../../app/components/marketing';
import { marketingFonts, marketingColors } from '../../app/components/tickitMarketingTheme';

export const SignUp = ({ signUp, isLoading, user, token }) => {
    const navigate = useNavigate();
    const [error, setError] = React.useState(null);
    const [terms, setTerms] = React.useState(false);

    if (user) {
        navigate(`/${token.split(" ")[0]}`);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        if (data.get("password") !== data.get("password-confirm")) {
            setError("Passwords Do Not Match");
        } else {
            signUp({
                name: data.get("name"),
                email: data.get("email"),
                phoneNumber: data.get("phoneNumber"),
                password: data.get("password"),
            });
        }
    };

    return (
        <MarketingFormPage
            maxWidth="sm"
            title="Create account"
            subtitle="Join Tickit and start discovering amazing events"
            loading={isLoading}
        >
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                {error && (
                    <Typography role="alert" sx={{ color: 'error.main', mb: 2, fontSize: '0.875rem' }}>
                        {error}
                    </Typography>
                )}
                <MainInput margin="normal" required fullWidth id="name" label="Full Name" name="name" />
                <MainInput margin="normal" type="email" required fullWidth id="email" label="Email" name="email" />
                <MainInput margin="normal" fullWidth required id="phoneNumber" label="Phone Number" name="phoneNumber" />
                <MainPassword margin="normal" sx={{ my: 1 }} required fullWidth name="password" label="Password" id="password" autoComplete="new-password" />
                <MainPassword margin="normal" sx={{ my: 1 }} required fullWidth name="password-confirm" label="Confirm Password" id="password-confirm" error={error} />
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                    <Checkbox
                        checked={terms}
                        onChange={() => setTerms(!terms)}
                        sx={{ color: marketingColors.gray500, mt: -0.5, '&.Mui-checked': { color: marketingColors.p700 } }}
                    />
                    <Typography variant="body2" sx={{ color: marketingColors.gray600, fontFamily: marketingFonts.body, lineHeight: 1.5 }}>
                        I agree to the{' '}
                        <NavLink to="/terms" target="_blank" style={{ color: marketingColors.p700, textDecoration: 'none', fontWeight: 600 }}>
                            Terms & Conditions
                        </NavLink>
                    </Typography>
                </Box>
                <MarketingButton type="submit" fullWidth disabled={!terms} sx={{ mt: 2, mb: 2 }}>
                    Create account
                </MarketingButton>
            </Box>
        </MarketingFormPage>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.auth?.isLoading,
    token: state?.auth?.token,
});

const mapDispatchToProps = { signUp };

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
